import { AuctionBidsRepository } from 'application/repositories/AuctionBidsRepository';
import {
    AuctionBidsDetailResponse,
    AuctionBidsPriceResponse,
} from 'domain/entities/AuctionBidsEntity';
import { PostPutDeleteBaseResponse } from 'domain/entities/CommonEntity';
import axiosConfig from 'infrastructure/config/axios';

export class AuctionBidsAPI implements AuctionBidsRepository {
    async getAuctionBidsDetail(params: { auctionId: number }): Promise<AuctionBidsDetailResponse> {
        const API_URL = '/auction-bids/detail';
        const response = await axiosConfig.getAxiosConfig().get(API_URL, { params });
        return response.data;
    }

    async updateDealProcedures(params: {
        propertyDealProcedures: {
            buyerMemberType: string;
            loanUseStatus: number;
        };
        auctionId: number;
    }): Promise<PostPutDeleteBaseResponse> {
        const API_URL = '/property/deal/procedures';
        const response = await axiosConfig.getAxiosConfig().put(API_URL, params);
        return response.data;
    }

    async getAuctionBidsPrice(params: {
        listedPropertyId: number;
    }): Promise<AuctionBidsPriceResponse> {
        const API_URL = '/auction-bids/price';
        const response = await axiosConfig.getAxiosConfig().get(API_URL, { params });
        return response.data;
    }

    async creatAuctionBids(params: {
        auctionId: number;
        scheduleSeq: number;
        bidPrice: number;
    }): Promise<PostPutDeleteBaseResponse> {
        const API_URL = '/auction-bids/create';
        const response = await axiosConfig.getAxiosConfig().post(API_URL, params);
        return response.data;
    }
}
